(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cost-type', {
            parent: 'entity',
            url: '/cost-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.costType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cost-type/cost-types.html',
                    controller: 'CostTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('costType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cost-type-detail', {
            parent: 'entity',
            url: '/cost-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.costType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cost-type/cost-type-detail.html',
                    controller: 'CostTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('costType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CostType', function($stateParams, CostType) {
                    return CostType.get({id : $stateParams.id});
                }]
            }
        })
        .state('cost-type.new', {
            parent: 'cost-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-type/cost-type-dialog.html',
                    controller: 'CostTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cost-type', null, { reload: true });
                }, function() {
                    $state.go('cost-type');
                });
            }]
        })
        .state('cost-type.edit', {
            parent: 'cost-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-type/cost-type-dialog.html',
                    controller: 'CostTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CostType', function(CostType) {
                            return CostType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cost-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cost-type.delete', {
            parent: 'cost-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cost-type/cost-type-delete-dialog.html',
                    controller: 'CostTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CostType', function(CostType) {
                            return CostType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cost-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
